var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KChip',_vm._b({},'KChip',_vm.settings,false),[_vm._v(_vm._s(_vm.status.name))])
}
var staticRenderFns = []

export { render, staticRenderFns }